
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M192 192h88.553v45.391h1.266C294.139 215.294 324.298 192 369.24 192 462.713 192 480 250.188 480 325.867V480h-92.305V343.361c0-32.592-.667-74.513-48.014-74.513-48.074 0-55.41 35.493-55.41 72.146V480H192V192zm-160 0h96v288H32V192zm96-80c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48z"}})])
          )
        }
      }
    